import { Input } from "antd";

import { RVFormFloatingLabelWrap } from "@regal-voice/ui";

export function NodeNameFormItem({ nodeName, title }: { nodeName?: string; title?: string }): JSX.Element {
    return (
        <RVFormFloatingLabelWrap
            name="nodeName"
            formItemHeader="Name of Condition"
            showFormLabel
            label={`${title || "Node Name"} (Optional)`}
        >
            <Input value={nodeName} />
        </RVFormFloatingLabelWrap>
    );
}
